import { z } from 'zod';
import type { GetConditionalTransitionDto } from '../types/GetConditionalTransitionDto';

export const getConditionalTransitionDtoSchema = z.union([
  z.object({
    id: z.string().uuid(),
    sourceCardId: z.string().uuid(),
    destinationCardId: z.string().uuid(),
    creatorId: z.string().uuid(),
    type: z.enum(['numberOfCorrectAnswers']),
    value: z.number().int(),
  }),
  z.object({
    id: z.string().uuid(),
    sourceCardId: z.string().uuid(),
    destinationCardId: z.string().uuid(),
    creatorId: z.string().uuid(),
    type: z.enum(['selectedOption']),
    value: z.string(),
  }),
]) as z.ZodType<GetConditionalTransitionDto>;
